<servicerapport-accordion-panel [formGroup]="formGroup" [title]="'Batteriskift'">
    <mat-accordion>
        <mat-expansion-panel #panel [expanded]="true">
            <mat-expansion-panel-header>
                <accordion-status-indicator [formGroup]="formGroup"></accordion-status-indicator>
                <mat-panel-title>Batteriskift</mat-panel-title>
                <mat-panel-description></mat-panel-description>
            </mat-expansion-panel-header>

            <!-- Dato -->
            <dff-form-control [formControl]="formGroup.get('dato.aktuel')"></dff-form-control>

            <!-- Måleraflæsning før batteriskifte -->
            <mat-divider></mat-divider>
            <h2>Måleraflæsning før batteriskifte</h2>
            <maaler-aflaesning [formGroup]="formGroup.get('maalerFoerBatteriskift')"></maaler-aflaesning>
            <div class="footer"><small>* sidst fakturerede aflæsning</small></div>
            <simpel-note-liste
                ingenNoterTekst=""
                [maxNoter]="1"
                [formArray]="formGroup.get('maalerFoerBatteriskift.noter')"
                [defaultOmraadeId]="defaultNoteOmraadeId"
                [omraader]="noteOmraader"
                [henvendelsestyper]="noteHenvendelsestyper"
                [opgavestyringStatusser]="noteOpgavestyringStatusser"
                [brugere]="noteBrugere"
                (initialiserNote)="onInitialiserNotePaaGammelMaaler($event, formGroup.get('maalerFoerBatteriskift.maalerNr.aktuel').value)"
            >
            </simpel-note-liste>

            <!-- Føj til huskeliste -->
            <mat-divider></mat-divider>
            <h2>Føj til huskeliste</h2>
            <dff-form-control [formControl]="formGroup.get('huskelisteId.aktuel')"></dff-form-control>
        </mat-expansion-panel>
    </mat-accordion>
</servicerapport-accordion-panel>
